import { useRevealAnimation } from "@/motion/hooks";
import { useEffect, useRef, useState } from "react";
import { SITE } from "@/config";

const CURATOR_SRC =
    "https://cdn.curator.io/published/d929ac4a-bed4-4871-8d65-8bed95139935.js";

export default function InstagramEmbed() {
    const revealRef = useRevealAnimation("cinematic");
    const ref = useRef(null);
    const [load, setLoad] = useState(false);

    // Lazy-init: only load the Curator widget once the section scrolls into view.
    useEffect(() => {
        if (!ref.current) return;
        const obs = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setLoad(true);
                    obs.disconnect();
                }
            },
            { rootMargin: "200px" }
        );
        obs.observe(ref.current);
        return () => obs.disconnect();
    }, []);

    useEffect(() => {
        if (!load) return;
        if (document.querySelector(`script[src="${CURATOR_SRC}"]`)) return;
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.charset = "UTF-8";
        s.src = CURATOR_SRC;
        const first = document.getElementsByTagName("script")[0];
        first.parentNode.insertBefore(s, first);
    }, [load]);

    return (
        <section ref={revealRef}
            id="instagram"
            ref={ref}
            data-testid="instagram-section"
            className="relative border-b border-[color:var(--line)] bg-[#030303] py-24 md:py-36"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10">
                <div className="text-center">
                    <p className="text-[10px] uppercase tracking-luxe text-[color:var(--gold)]">
                        On Instagram
                    </p>
                    <h2 className="font-display mt-4 text-5xl md:text-6xl">{SITE.instagramHandle}</h2>
                    <a
                        href={SITE.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="instagram-follow"
                        className="link-gold mt-5 inline-block text-xs uppercase tracking-[0.2em] text-[color:var(--gold)]"
                    >
                        Follow the feed
                    </a>
                </div>

                <div className="mt-12">
                    {load ? (
                        <div id="curator-feed-default-feed-layout" data-testid="curator-feed">
                            <a
                                href="https://curator.io"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="crt-logo crt-tag"
                            >
                                Powered by Curator.io
                            </a>
                        </div>
                    ) : (
                        <div className="flex h-40 items-center justify-center text-[color:var(--muted)] text-sm">
                            Loading feed…
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
